import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  loadWorkers,
  loadWorkersError,
  loadWorkersSuccess,
} from './+state/actions';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PreloadWorkersResolver implements Resolve<boolean> {
  resolve(): Observable<boolean> {
    this.store.dispatch(loadWorkers());
    return this.actions$.pipe(
      ofType(loadWorkersSuccess, loadWorkersError),
      map(() => true),
      first()
    );
  }

  constructor(private actions$: Actions, private store: Store) {}
}
